  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".reverse-button").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default behavior

            let card = this.closest(".card-wrapper");
            card.classList.toggle("reverse-active");
        });
    });
  });

